var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bem.tipoPai === 1)?_c('div',[_c('div',{staticClass:"btn-veiculo-verificado"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }